// extracted by mini-css-extract-plugin
export default {"comingSoon":"style_comingSoon__IXmob"};